import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import { z } from 'zod';

import {
  PostQaAttemptError,
  PostQaAttemptVariables,
  fetchPostQaAttempt,
} from '../toolkitComponents.js';
import { useToolkitContext } from '../toolkitContext.js';
import { Registry } from './registry.js';

type Response = z.infer<typeof schResponse>;
const {
  schemas: { REQUEST: schRequest, RESPONSE: schResponse },
} = Registry.postQaAttempt;

export const usePostQaAttempt = (
  options?: Omit<
    UseMutationOptions<Response, PostQaAttemptError, PostQaAttemptVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useToolkitContext();

  return useMutation<Response, PostQaAttemptError, PostQaAttemptVariables>(
    (variables: PostQaAttemptVariables) =>
      fetchPostQaAttempt({
        ...fetcherOptions,
        ...variables,
        body: schRequest.BODY.parse(variables.body),
      }).then((r) => schResponse.parse(r)),
    options,
  );
};
